import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconNumberedList = ({ t, className, height, width, fill }) => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'
    width={width} height={height} viewBox='0 0 25 25'>
    <defs>
      <path id='a' d='M0 0h25v25H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <mask id='b' fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <use xlinkHref='#a' />
      <path fill={fill} d='M5.847 10.813H4.722V6.372l-1.344.426v-.937L5.726 5h.121v5.813zM7 20H3.113v-.79l1.834-2.001c.252-.282.439-.528.56-.738.12-.21.18-.41.18-.598 0-.258-.063-.46-.19-.608-.128-.147-.31-.221-.546-.221a.736.736 0 0 0-.601.269c-.147.18-.22.415-.22.708H3c0-.354.082-.677.247-.97.165-.292.398-.52.7-.687.3-.166.642-.25 1.024-.25.584 0 1.038.144 1.361.431.323.288.485.693.485 1.217 0 .287-.073.579-.218.877-.146.297-.395.644-.748 1.04l-1.29 1.392H7V20zm2-2.143h12V20H9v-2.143zm0-4.286h12v2.143H9v-2.143zm0-4.285h12v2.143H9V9.286zM9 5h12v2.143H9V5z'
        mask='url(#b)' />
    </g>
  </svg>
)

export default Icon(IconNumberedList)
